import i18n from 'i18n-js';
import memoize from 'lodash.memoize';

export const tranlsationGetters = {
    en: {
        general: {
            title: 'Student',
        },
        loginScreen: {
            email: 'Email',
            password: 'Password',
            login: 'Login',
            loginError: 'Invalid email or password',
        },
        HomeScreen: {
            title: 'Home',
        },
        MatchesScreen: {
            title: 'Matches',
            TeamsList: {
                addTeam : 'Add Team',
            }
        }
    },
    ar: {
        hello: 'اهلا بك'
    }
};

export const translate = memoize(
    (key: any, config: any) => i18n.t(key, config),
    (key: any, config: any) => (config ? key + JSON.stringify(config) : key),
);

export const setI18nConfig = () => {
    // fallback if no available language fits
    const fallback = { languageTag: 'en', isRTL: false };

    const { languageTag, isRTL } = fallback;

    // set i18n-js config
    i18n.translations = { [languageTag]: tranlsationGetters.en };
    i18n.locale = languageTag;
    // console.log(i18n.locale);
    // console.log(i18n.translations);
    // console.log(translationGetters[languageTag]());
    // console.log(i18n.locale);
    // console.log(i18n);
};